<template lang="html">
  <label class="input-label" :for="forId" @click="$emit('click')">
    <slot></slot>
    <div class="asterisk" v-if="isRequired">
      *
    </div>
  </label>
</template>

<script>
  export default {
    name: 'input_label',

    props: {
      forId: [String, Number],

      isRequired: {
        default: false
      }
    }
  }
</script>

<style lang="sass">
  @import '../../../styles/base/variables'
  @import '../../../styles/helpers/mixins'

  $translation: translateY(-21px) scale(.75)

  .asterisk
    fill: $color-error
    display: inline
    margin: 8px 4px

  .input-label
    font-size: 12px;
    text-transform: capitalize
    transform: translateY(0) scale(1)
    position: absolute
    top: 35px
    left: 0
    display: inline-block
    z-index: 2
    transition: transform $transition-duration $transition-easing, color $transition-duration $transition-easing
    transform-origin: 0 0
    cursor: text
    text-transform: capitalize
    user-select: none
    color: $color-text

    .has-focus &
     transform: $translation
     color: $color-primary

    .has-value &
      transform: $translation
      transition: color $transition-duration $transition-easing

</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/inputs/InputLabel.vue